import { BrowserTracing } from '@sentry/tracing';
import * as Sentry from '@sentry/vue';

/**
 * Adds custom context to Sentry crash reports.
 */
export const addContextToSentry = (name, context) => {
    Sentry.setContext(name, context);
};

/**
 * Adds user data to Sentry scope.
 */
export const addUserToSentry = user => {
    Sentry.configureScope(scope => {
        scope.setUser(user);
    });
};

/**
 * Standard list of error messages to ignore in all projects.
 */
const defaultIgnoreErrors = [
    'ResizeObserver loop limit exceeded',
    'Avoided redundant navigation',
    'Failed to fetch dynamically imported module',
    /Loading chunk .* failed./,
    'Unable to preload CSS',
];

export default {
    async install(app, config) {
        if (process.env.NODE_ENV === 'production') {
            try {
                const options = {
                    app,
                    dsn: config.dsn,
                    release: config.release,
                    environment: process.env.NODE_ENV,
                    logErrors: true,
                    ignoreErrors: defaultIgnoreErrors.concat(
                        config.ignoreErrors ?? []
                    ),
                };

                if (config.tracing) {
                    options.integrations = [
                        new BrowserTracing({
                            routingInstrumentation: Sentry.vueRouterInstrumentation(
                                config.tracing.router
                            ),
                            tracingOrigins: [
                                /^\//,
                                ...config.tracing.tracingOrigins,
                            ],
                        }),
                    ];
                    options.tracesSampleRate =
                        config.tracing.tracesSampleRate ?? 0.4;
                }

                Sentry.init(options);
                // eslint-disable-next-line no-console
                console.warn(`Sentry: Enabled. Release is ${config.release}.`);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(
                    `Sentry failed to initialize. Release is ${config.release}.`,
                    err
                );
            }
        } else {
            // eslint-disable-next-line no-console
            console.warn(
                `Sentry: Disabled. Process is ${process.env.NODE_ENV}.`
            );
        }
    },
};
